$(function () {
  const socialShare = {
    init() {
      socialShare.create();
    },
    create() {
      const ele = $("[data-social-share]");
      if (ele.length == 0) return;

      ele.find('[data-toggle="close"]').on('click', function() {
        const self = $(this);

        self.closest('[data-share]').stop().fadeOut();
        $('[data-overlay]').stop().fadeOut();
        $('[data-cta-supports]').removeClass('active').removeClass('no-active');
      });
    },
  };

  socialShare.init();
});
